import "core-js/modules/es6.array.map";
import { jsx as ___EmotionJSX } from "@emotion/core";
import React, { Children, cloneElement } from 'react';
import { GridRoot as Root } from "./styled";
import { ALIGN_ITEMS, GUTTER_WIDTH } from "./constants";
import { gridPropTypes } from "./propTypes";

var getGridItems = function getGridItems(_ref) {
  var breakpoints = _ref.breakpoints,
      children = _ref.children,
      columns = _ref.columns,
      gutterWidth = _ref.gutterWidth;
  return Children.map(children, function (child) {
    return cloneElement(child, {
      breakpoints: breakpoints,
      columns: columns,
      gutterWidth: gutterWidth
    });
  });
};

var Grid = function Grid(props) {
  return ___EmotionJSX(Root, props, getGridItems(props));
};

Grid.displayName = 'Grid';
var defaultProps = {
  alignItems: ALIGN_ITEMS.stretch,
  // Same as Flex
  columns: 12,
  gutterWidth: GUTTER_WIDTH.md // Same as Flex

};
Grid.defaultProps = defaultProps;
Grid.propTypes = process.env.NODE_ENV !== "production" ? gridPropTypes : {};
export default Grid;